export const NeoAssignedVehicle: React.FC<any> = ({data, uid}) => {
  const assignedVehicle = data[uid];

  if (assignedVehicle === null || assignedVehicle === undefined) {
    return <div>-</div>;
  }

  return (
    <>
      <div className="mt-2">
        {assignedVehicle === true ? (
          <div className="flex h-6 w-12 flex-row items-center justify-center gap-1 rounded-md bg-[#349C421A] p-2">
            <div>
              <svg
                width="11"
                height="8"
                viewBox="0 0 11 8"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10.2814 0.219727C10.5744 0.512695 10.5744 0.988477 10.2814 1.28145L4.28145 7.28145C3.98848 7.57441 3.5127 7.57441 3.21973 7.28145L0.219727 4.28145C-0.0732422 3.98848 -0.0732422 3.5127 0.219727 3.21973C0.512695 2.92676 0.988477 2.92676 1.28145 3.21973L3.75176 5.6877L9.22207 0.219727C9.51504 -0.0732422 9.99082 -0.0732422 10.2838 0.219727H10.2814Z"
                  fill="#349C42"
                />
              </svg>
            </div>
            <div className="text-[#349C42]">Yes</div>
          </div>
        ) : (
          <div className="flex h-6 w-12 flex-row items-center justify-center gap-1 rounded-md bg-[#F28A031A] p-2">
            <div>
              <svg
                width="12"
                height="11"
                viewBox="0 0 12 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.99914 0C6.33195 0 6.63898 0.175781 6.80773 0.464062L11.8702 9.08906C12.0413 9.37969 12.0413 9.73828 11.8749 10.0289C11.7085 10.3195 11.3968 10.5 11.0616 10.5H0.936635C0.601479 10.5 0.28976 10.3195 0.123354 10.0289C-0.0430526 9.73828 -0.0407088 9.37734 0.128041 9.08906L5.19054 0.464062C5.35929 0.175781 5.66632 0 5.99914 0ZM5.99914 3C5.68742 3 5.43664 3.25078 5.43664 3.5625V6.1875C5.43664 6.49922 5.68742 6.75 5.99914 6.75C6.31085 6.75 6.56164 6.49922 6.56164 6.1875V3.5625C6.56164 3.25078 6.31085 3 5.99914 3ZM6.74914 8.25C6.74914 8.05109 6.67012 7.86032 6.52947 7.71967C6.38881 7.57902 6.19805 7.5 5.99914 7.5C5.80022 7.5 5.60946 7.57902 5.4688 7.71967C5.32815 7.86032 5.24914 8.05109 5.24914 8.25C5.24914 8.44891 5.32815 8.63968 5.4688 8.78033C5.60946 8.92098 5.80022 9 5.99914 9C6.19805 9 6.38881 8.92098 6.52947 8.78033C6.67012 8.63968 6.74914 8.44891 6.74914 8.25Z"
                  fill="#F28A03"
                />
              </svg>
            </div>
            <div className="text-[#F28A03]">No</div>
          </div>
        )}
      </div>
    </>
  );
};
<div className="flex h-3 w-6 flex-col items-center justify-center  gap-1 bg-[#349C421A]">
  <div>
    <svg
      width="11"
      height="8"
      viewBox="0 0 11 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.2814 0.219727C10.5744 0.512695 10.5744 0.988477 10.2814 1.28145L4.28145 7.28145C3.98848 7.57441 3.5127 7.57441 3.21973 7.28145L0.219727 4.28145C-0.0732422 3.98848 -0.0732422 3.5127 0.219727 3.21973C0.512695 2.92676 0.988477 2.92676 1.28145 3.21973L3.75176 5.6877L9.22207 0.219727C9.51504 -0.0732422 9.99082 -0.0732422 10.2838 0.219727H10.2814Z"
        fill="#349C42"
      />
    </svg>
  </div>
  <div>Yes</div>
</div>;
